require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()

import 'bootstrap'
// import "@fortawesome/fontawesome-free/js/all"

global.$ = $;